import { IconBell } from './Bell';
import { IconAsterisk } from './Asterisk';
import { IconBank } from './Bank';
import { IconBadge } from './Badge';
import { IconBars } from './Bars';
import { IconBulb } from './Bulb';
import { IconGrid } from './Grid';
import { IconExternal } from './External';
import { IconCalendarLayer } from './CalendarLayer';
import { IconDocument } from './Document';
import { IconDocumentEdit } from './DocumentEdit';
import { IconBusiness } from './Business';
import { IconCalendar } from './Calendar';
import { IconClipboard } from './Clipboard';
import { IconCopy } from './Copy';
import { IconChecklist } from './Checklist';
import { IconClock } from './Clock';
import { IconCalendarClock } from './CalendarClock';
import { IconCode } from './Code';
import { IconDots } from './Dots';
import { IconEye } from './Eye';
import { IconEyeClosed } from './EyeClosed';
import { IconFilters } from './Filters';
import { IconFolder } from './Folder';
import { IconGlobe } from './Globe';
import { IconHome } from './Home';
import { IconHandCoins } from './HandCoins';
import { IconHelmet } from './Helmet';
import { IconKey } from './Key';
import { IconList } from './List';
import { IconListAdd } from './ListAdd';
import { IconLock } from './Lock';
import { IconOffline } from './Offline';
import { IconQuestionMark } from './QuestionMark';
import { IconLoading } from './Loading';
import { IconMarker } from './Marker';
import { IconMail } from './Mail';
import { IconMailbox } from './Mailbox';
import { IconMailboxEmpty } from './MailboxEmpty';
import { IconMoney } from './Money';
import { IconMoneyReturn } from './MoneyReturn';
import { IconMoon } from './Moon';
import { IconOverdraft } from './Overdraft';
import { IconOverdraftMoney } from './OverdraftMoney';
import { IconPhone } from './Phone';
import { IconPiggy } from './Piggy';
import { IconPhoneAdd } from './PhoneAdd';
import { IconScanCheck } from './ScanCheck';
import { IconSearch } from './Search';
import { IconSearchList } from './SearchList';
import { IconSettings } from './Settings';
import { IconShield } from './Shield';
import { IconSign } from './Sign';
import { IconSignal } from './Signal';
import { IconSun } from './Sun';
import { IconTheme } from './Theme';
import { IconToggles } from './Toggles';
import { IconUser } from './User';
import { IconUsers } from './Users';
import { IconUsersArrow } from './UsersArrow';
import { IconWarning } from './Warning';
import { IconLayers } from './Layers';
import { IconWallet } from './Wallet';
import { IconMoneyIn } from './MoneyIn';
import { IconMoneyOut } from './MoneyOut';
import { IconChecks } from './Checks';
import { IconParty } from './Party';
import { IconReset } from './Reset';
import { IconReturn } from './Return';
import { IconPin } from './Pin';
import { IconHamburger } from './Hamburger';
export const IconMisc = {
    Asterisk: IconAsterisk,
    Hamburger: IconHamburger,
    Bank: IconBank,
    Badge: IconBadge,
    Bell: IconBell,
    Bars: IconBars,
    Bulb: IconBulb,
    Grid: IconGrid,
    CalendarLayer: IconCalendarLayer,
    Checks: IconChecks,
    Document: IconDocument,
    DocumentEdit: IconDocumentEdit,
    Dots: IconDots,
    External: IconExternal,
    Clipboard: IconClipboard,
    Copy: IconCopy,
    Clock: IconClock,
    Checklist: IconChecklist,
    Marker: IconMarker,
    Mail: IconMail,
    Mailbox: IconMailbox,
    MailboxEmpty: IconMailboxEmpty,
    Search: IconSearch,
    SearchList: IconSearchList,
    Settings: IconSettings,
    Business: IconBusiness,
    User: IconUser,
    QuestionMark: IconQuestionMark,
    Folder: IconFolder,
    Globe: IconGlobe,
    Pin: IconPin,
    Home: IconHome,
    Offline: IconOffline,
    HandCoins: IconHandCoins,
    Helmet: IconHelmet,
    Users: IconUsers,
    Calendar: IconCalendar,
    CalendarClock: IconCalendarClock,
    List: IconList,
    ListAdd: IconListAdd,
    Lock: IconLock,
    Loading: IconLoading,
    Overdraft: IconOverdraft,
    OverdraftMoney: IconOverdraftMoney,
    Signal: IconSignal,
    Filters: IconFilters,
    Theme: IconTheme,
    Toggles: IconToggles,
    Phone: IconPhone,
    Party: IconParty,
    Piggy: IconPiggy,
    PhoneAdd: IconPhoneAdd,
    ScanCheck: IconScanCheck,
    Shield: IconShield,
    Sign: IconSign,
    Code: IconCode,
    Eye: IconEye,
    Money: IconMoney,
    MoneyReturn: IconMoneyReturn,
    EyeClosed: IconEyeClosed,
    Sun: IconSun,
    Moon: IconMoon,
    Reset: IconReset,
    Return: IconReturn,
    Key: IconKey,
    Warning: IconWarning,
    UsersArrow: IconUsersArrow,
    Layers: IconLayers,
    Wallet: IconWallet,
    MoneyIn: IconMoneyIn,
    MoneyOut: IconMoneyOut,
};
//# sourceMappingURL=index.js.map